import { FC } from 'react';
import {
  CloseButton,
  Container,
  Dialog as ChakraDialog,
} from '@chakra-ui/react';

import { CLOSE_BUTTON_OFFSET } from './constants';
import { FullScreenDialogProps } from './types';

export const FullScreenDialog: FC<FullScreenDialogProps> = ({
  children,
  containerMaxW,
  showClose = true,
  decoration,
  ...props
}) => (
  <ChakraDialog.Root size="full" {...props}>
    <ChakraDialog.Backdrop />
    <ChakraDialog.Positioner>
      <ChakraDialog.Content>
        {showClose && (
          <ChakraDialog.CloseTrigger asChild>
            <CloseButton
              right={CLOSE_BUTTON_OFFSET}
              top={CLOSE_BUTTON_OFFSET}
            />
          </ChakraDialog.CloseTrigger>
        )}

        <ChakraDialog.Body
          bg="primary.50"
          color="navy.500"
          display="flex"
          p={5}
        >
          <Container m="auto" maxW={containerMaxW} p={0} zIndex="popover">
            {children}
          </Container>
        </ChakraDialog.Body>

        {decoration}
      </ChakraDialog.Content>
    </ChakraDialog.Positioner>
  </ChakraDialog.Root>
);
